import {
    DateFilterChips,
    FilteringOptionsPanel,
    StatusFilterChips,
} from "@/ui";
import styles from "./OrderHistoryFilter.module.scss";

const STATUS_OPTIONS = [
    "PENDING",
    "APPROVED",
    "READY",
    "DELIVERED",
    "VOID",
    "DECLINED",
    "REFUNDED",
    "DELIVERY_STARTED",
    "DELIVERY_FINISHED",
].map(value => ({
    value,
    label: value.replace(/_/g, " "),
}));

const startOfDayUnix = date =>
    Math.floor(
        new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
        ).getTime() / 1000,
    );

const endOfDayUnix = date =>
    Math.floor(
        new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            23,
            59,
            59,
        ).getTime() / 1000,
    );

const OrderHistoryFilter = ({
    filterStatus,
    setFilterStatus,
    filterDateStart,
    setFilterDateStart,
    filterDateEnd,
    setFilterDateEnd,
}) => {
    const handleDatePreset = (start, end) => {
        setFilterDateStart(start ?? null);
        setFilterDateEnd(end ?? null);
    };

    const handleDateRangeChange = range => {
        if (!range?.from || !range?.to) return;
        setFilterDateStart(startOfDayUnix(range.from));
        setFilterDateEnd(endOfDayUnix(range.to));
    };

    return (
        <FilteringOptionsPanel
            className={`${styles.root} order-history-filter`}
            sections={[
                {
                    key: "date",
                    title: "Date",
                    content: (
                        <DateFilterChips
                            end={filterDateEnd}
                            onPreset={handleDatePreset}
                            onRangeChange={handleDateRangeChange}
                            start={filterDateStart}
                        />
                    ),
                },
                {
                    key: "status",
                    title: "Status",
                    content: (
                        <StatusFilterChips
                            onSelect={setFilterStatus}
                            options={STATUS_OPTIONS}
                            selected={filterStatus}
                            showAll
                        />
                    ),
                },
            ]}
        />
    );
};

export default OrderHistoryFilter;
